export const activeRoute = (
  routeName: string,
  pathname: string,
  exact?: boolean
) => {
  if (exact) {
    return pathname === routeName;
  } else {
    return pathname.includes(routeName);
  }
};
